import { render, staticRenderFns } from "./booking-acl-email-button.vue?vue&type=template&id=215f9fe1&"
import script from "./booking-acl-email-button.vue?vue&type=script&lang=js&"
export * from "./booking-acl-email-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports